// https://www.typescriptlang.org/docs/handbook/release-notes/typescript-3-7.html#assertion-functions
export function assertDefined<T>(val: T): asserts val is NonNullable<T> {
  if (val === undefined) {
    throw new Error("val is undefined");
  }
}
